module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/bpic05.027ed48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newhome/bpic05.png
// module id = h2zX
// module chunks = 0